/* eslint-disable react-hooks/exhaustive-deps */
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, ButtonBase, Menu, MenuItem, Typography } from "@mui/material";
import React, { useMemo } from "react";
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import useChangeLanguage from "../../common/hooks/useChangeLanguage";
import { LOCAL_STORAGE, getDataSession } from "helper/session";
import { KEY_ROLE_BIZZ_UAA, ROLE } from "modules/UAA/configs/constant";
// import { CommonAPI } from "api/UAA/Common";

// const getListLanguage = (params) => {
//   return commonApi({ url: "/api/v1/language", method: "get", params });
// };

export const LIST_LANGUAGUE = [
  {
    name: "English",
    code: "ENG",
    flag: "US",
    codeHeader: "en-US",
  },
  {
    name: "Haiti",
    code: "HT",
    flag: "HT",
    codeHeader: "rn-BI",
  },
  {
    name: "France",
    code: "FR",
    flag: "FR",
    codeHeader: "fr-FR",
  },
];

const LanguageButton = (props) => {
  const { hiddenArrow, changeUserLanguage } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const { changeLanguage } = useChangeLanguage();
  const { t } = useTranslation("uaa");
  const open = Boolean(anchorEl);

  const currentUserRole = getDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA);

  const LIST_LANGUAGE_BY_USER = useMemo(() => {
    if (pathname === "/login") {
      return LIST_LANGUAGUE;
    } else {
      const list_lang_temp =
        currentUserRole?.code === ROLE.ADMIN
          ? LIST_LANGUAGUE.slice(0, 1)
          : LIST_LANGUAGUE;

      return list_lang_temp;
    }
  }, [currentUserRole, i18n]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeLangue = async (lang) => {
    if (pathname !== "/login" && currentUserRole?.code !== ROLE.ADMIN) {
      const selectedLanguage = LIST_LANGUAGE_BY_USER.find(
        (v) => v.code === lang
      );
      const { data } = await changeUserLanguage({
        language: selectedLanguage?.codeHeader,
      });
      if (data.hasOwnProperty("errorCodes")) {
        changeLanguage(currentLangue.flag.toLowerCase());
      } else {
        changeLanguage(lang.toLowerCase());
        toast.success(t(`message.change-lang-succ`));
      }
    } else {
      changeLanguage(lang.toLowerCase());
      toast.success(t(`message.change-lang-succ`));
    }
    handleClose();
  };

  const currentLangue = LIST_LANGUAGE_BY_USER.find(
    (v) => v.code.toLowerCase() === i18n.language
  );

  if (currentLangue) {
    return (
      <Box>
        <ButtonBase className="p-2" onClick={handleClick}>
          <ReactCountryFlag
            countryCode={currentLangue?.flag}
            svg
            style={{ fontSize: "20px" }}
            className="mr-4 w-10 h-10"
          />
          <Typography variant="body2">{currentLangue?.name}</Typography>
          {!hiddenArrow && (
            <>
              {open ? (
                <KeyboardArrowUpIcon fontSize="small" />
              ) : (
                <KeyboardArrowDownIcon fontSize="small" />
              )}
            </>
          )}
        </ButtonBase>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {LIST_LANGUAGE_BY_USER.map((item, index) => {
            return (
              <MenuItem
                onClick={() => handleChangeLangue(item.code)}
                key={index}
              >
                <ReactCountryFlag
                  countryCode={item?.flag}
                  svg
                  style={{ fontSize: "20px" }}
                  className="mr-4 w-10 h-10"
                />
                <Typography variant="body2">{item?.name}</Typography>
              </MenuItem>
            );
          })}
        </Menu>
      </Box>
    );
  }
  return null;
};

export default LanguageButton;
